import { Form } from 'antd';
import type { NamePath } from 'rc-field-form/es/interface';
import React from 'react';

const { Item } = Form;

function toArray<T>(value?: T | T[] | null): T[] {
  if (value === undefined || value === null) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
}

function get(
  entity: Record<string | number, unknown>,
  path: (string | number)[] | readonly (string | number)[]
): unknown {
  let current: unknown = entity;

  for (let i = 0; i < path.length; i += 1) {
    if (current === null || current === undefined) {
      return undefined;
    }

    current = (current as Record<string | number, unknown>)[path[i]];
  }

  return current;
}

type MemoFieldProps<T> = {
  name: NamePath;
  children: (value: T) => React.ReactNode;
};

export const MemoField = <T,>({ name, children }: MemoFieldProps<T>) => {
  return (
    <Item
      noStyle
      shouldUpdate={(
        prev: Record<string, unknown>,
        next: Record<string, unknown>
      ) => {
        const namePath = toArray<string | number>(
          name as string | number | (string | number)[]
        );

        const prevVal = get(prev, namePath);
        const nextVal = get(next, namePath);

        return prevVal !== nextVal;
      }}
    >
      {(form) => children(form.getFieldValue(name) as T)}
    </Item>
  );
};
